"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.RouterContext = void 0;
var _interop_require_default = require("@swc/helpers/lib/_interop_require_default.js").default;
var _react = _interop_require_default(require("react"));
const RouterContext = _react.default.createContext(null);
exports.RouterContext = RouterContext;
if (process.env.NODE_ENV !== 'production') {
    RouterContext.displayName = 'RouterContext';
}

//# sourceMappingURL=router-context.js.map